import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import * as Common from "../commons/common";
import * as Request from "../commons/request";
import * as Types from "../commons/typeDTO";
import * as Strings from "../commons/string";
import * as Utils from "../utils/utils";

import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { Col, Form, Row } from "antd";

function ReturnBatteryState() {
    const params = useParams();
    const navigate = useNavigate();

    const [currentRentId, setCurrentRentId] = useState<number>();
    const [rent, setRent] = useState<Types.RentDto>();

    useEffect(() => {
        if (params.rentId) setCurrentRentId(Number(params.rentId));
    }, [params.rentId]);

    useEffect(() => {
        Utils.onEvent(Common.EVENT_NEXT_PROCESS, goToNextProcess);

        currentRentId && requestGetRent();

        Utils.triggerEvent(Common.EVENT_ENABLE_PROCESS_BUTTON, true);

        return () => {
            Utils.offEvent(Common.EVENT_NEXT_PROCESS, goToNextProcess);
        };
    }, [currentRentId]);

    const requestAxiosGetRent = async () => {
        const response = await utilAxiosWithAuth().get(Request.RENT_URL + currentRentId);
        return response.data;
    };

    const { loading: loadingGetRent, error: errorGetRent, data: resultGetRent, execute: requestGetRent } = useAsyncAxios(requestAxiosGetRent);

    useEffect(() => {
        if (resultGetRent === null) return;
        console.log("resultGetRent", resultGetRent);
        setRent(resultGetRent.rent);
    }, [resultGetRent]);

    useEffect(() => {
        if (errorGetRent === null) return;
        console.log("errorGetRent", errorGetRent);
    }, [errorGetRent]);

    const goToNextProcess = () => {
        // navigate(Common.PAGE_RETURN_ADDIMAGE + "/" + currentRentId);     // skip Add Image
        navigate(Common.PAGE_RETURN_CHECKLIST + "/" + currentRentId);
    };

    return (
        <div>
            <Form layout="inline">
                <Row>
                    <Col xs={{ span: 24 }} sm={{ span: 12 }} className="d-none">
                        <Form.Item className="searchForm" name="startBatterySoc" label="출차 배터리 상태">
                            <span>{rent?.startBatterySoc ? rent.startBatterySoc + "%" : Strings.dash}</span>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 12 }} className="d-none">
                        <Form.Item className="searchForm searchLastRow" name="endBatterySoc" label="도착 배터리 상태">
                            <span>{rent?.endBatterySoc ? rent.endBatterySoc + "%" : Strings.dash}</span>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </div>
    );
}

export default ReturnBatteryState;
